// 03a — email entry. One field. The "stuck? text me" line is always visible,
// never behind a disclosure. The not-listed panel never says "not authorized".
import { Icon } from '../../lib/icons';
import { MONO } from '../primitives';

const CARD: React.CSSProperties = {
  background: 'var(--deeper)',
  border: '1px solid rgba(127,227,232,0.24)',
  borderRadius: 16,
  padding: '22px 20px',
};

export function EmailStep({
  email,
  onEmail,
  onSend,
  busy,
  notListed,
}: {
  email: string;
  onEmail: (v: string) => void;
  onSend: () => void;
  busy: boolean;
  notListed: boolean;
}) {
  return (
    <div className="on-card" style={CARD}>
      <label
        htmlFor="wh-email"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          fontSize: 21,
          fontWeight: 700,
          letterSpacing: '-0.02em',
          marginBottom: 6,
        }}
      >
        <Icon name="mail" size={28} color="var(--cyan)" style={{ flex: 'none' }} />
        what's your email?
      </label>
      <div style={{ fontSize: 17, color: 'var(--muted)', marginBottom: 14 }}>
        we'll email you a six-digit code.
      </div>
      <input
        id="wh-email"
        className="wh-input"
        type="email"
        inputMode="email"
        autoComplete="email"
        autoCapitalize="off"
        spellCheck={false}
        placeholder="you@example.com"
        value={email}
        onChange={(e) => onEmail(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSend();
        }}
        style={{ minHeight: 60, padding: '14px 16px', fontSize: 20 }}
      />

      {notListed && (
        <div
          style={{
            marginTop: 14,
            background: 'rgba(255,59,31,0.13)',
            border: '1px solid var(--orange)',
            borderRadius: 12,
            padding: 16,
          }}
        >
          <div style={{ fontSize: 19, fontWeight: 700, lineHeight: 1.35 }}>
            that address isn't on the list yet.
          </div>
          <div style={{ fontSize: 17, color: 'var(--body-2)', lineHeight: 1.5, marginTop: 6 }}>
            i typed this list from memory. text me and i'll add you.
          </div>
        </div>
      )}

      <button
        type="button"
        className="wh-cta on-card"
        onClick={onSend}
        disabled={busy}
        style={{ width: '100%', minHeight: 62, marginTop: 16, fontSize: 21, fontWeight: 700 }}
      >
        email me a code
      </button>

      <div
        style={{
          fontFamily: MONO,
          fontSize: 14,
          lineHeight: 1.6,
          color: 'var(--muted)',
          marginTop: 18,
          borderTop: '1px solid var(--hairline)',
          paddingTop: 16,
        }}
      >
        stuck? text me and i'll do it for you.
      </div>
    </div>
  );
}
